import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import useIsMobile from "Shared/hooks/useIsMobile";
import useLang from "Shared/hooks/useLanguage";
import React, { useEffect, useMemo, useRef, useState } from "react";
import BootstrapModal from "react-bootstrap/Modal";
import Select from "react-select";
import { toast } from "react-toastify";
import OncologyPanelMappingService from "Services/OncologyCompendiumServices/OncologyPanelMappingService";
import { Loader } from "Shared/Common/Loader";
import NoRecord from "Shared/Common/NoRecord";
import PermissionComponent from "Shared/Common/Permissions/PermissionComponent";
import { ArrowDown, ArrowUp } from "Shared/Icons";
import { StringRecord } from "Shared/Type";
import { reactSelectSMStyle, styles } from "Utils/Common";
import { SortingTypeI, sortById } from "Utils/consts";
import Row, { ITableObj } from "./Row";
import ArchivedIdCompendium from "./archived";
import { useMutation, useQuery, useQueryClient } from "react-query";
import CustomPagination from "Shared/JsxPagination";

interface IAssayData {
  assayNameId: string | number;
  assayName: string;
  organism: string | number;
  testCode: string | number;
}
export interface IRows {
  id: number;
  panelId: number;
  performingLabId: number;
  performingLabName: string;
  panelName: string;
  panelCode: string;
  assayName: string;
  organism: string;
  testCode: string;
  groupName: string;
  antibioticClass: string;
  subPanelName: string;
  assayNameId: number;
  reportingRuleId: number;
  groupNameId: number;
  reportingRuleName: string;
  resistance: boolean;
  numberOfDetected: number | null;
  numberOfRepeated: number | null;
  createDate: string;
  rowStatus: boolean | undefined;
}
interface NavProps {
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  refresh: boolean;
}
export default function CollapsibleTable({ setRefresh, refresh }: NavProps) {
  const { t } = useLang();
  const isMobile = useIsMobile();
  const [triggerSearchData, setTriggerSearchData] = useState(false);
  const [sort, setSorting] = useState<SortingTypeI>(sortById);
  const [isArchivedModalShown, showArchivedModal] = useState(false);
  //============================================================================================
  //====================================  PAGINATION START =====================================
  //============================================================================================

  const [curPage, setCurPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [total, setTotal] = useState<number>(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumbers, setPageNumbers] = useState<number[]>([]);
  const nextPage = () => {
    if (curPage < Math.ceil(total / pageSize)) {
      setCurPage(curPage + 1);
    }
  };

  const showPage = (i: number) => {
    setCurPage(i);
  };

  const prevPage = () => {
    if (curPage > 1) {
      setCurPage(curPage - 1);
    }
  };
  const closeArchivedModal = () => {
    showArchivedModal(false);
  };
  useEffect(() => {
    setTotalPages(Math.ceil(total / pageSize));
    const pgNumbers = [];
    for (let i = curPage - 2; i <= curPage + 2; i++) {
      if (i > 0 && i <= totalPages) {
        pgNumbers.push(i);
      }
    }
    setPageNumbers(pgNumbers);
  }, [total, curPage, pageSize, totalPages]);

  //============================================================================================
  //====================================  PAGINATION END =======================================
  //============================================================================================

  const queryClient = useQueryClient();
  const [rows, setRows] = useState<IRows[]>(() => []);

  const [request, setRequest] = useState(false);

  const handleChange = (name: string, value: any, id: number) => {
    setRows((curr) =>
      curr.map((x) =>
        x.id === id
          ? {
            ...x,
            [name]: value,
          }
          : x
      )
    );
  };
  const handleChangeforRepeated = (name: string, value: any, id: number) => {
    const parsedValue = parseInt(value, 10);
    const temprow = rows.find((row) => row.id === id);

    if (
      temprow?.numberOfDetected != null &&
      parsedValue < temprow?.numberOfDetected
    ) {
      toast.error(
        t(
          "NumberOfRepeated value must be greater than or equal to numberOfDetected"
        )
      );
    } else {
      setRows((curr) =>
        curr.map((x) =>
          x.id === id
            ? {
              ...x,
              [name]: isNaN(parsedValue) ? "" : parsedValue,
            }
            : x
        )
      );
    }
  };

  const handleChangeForDetected = (name: string, value: any, id: number) => {
    // Assuming you have a state variable to store the rows
    const updatedRows = rows.map((row: any) => {
      if (row.id === id) {
        // Validate that the input is a valid integer
        const parsedValue = parseInt(value, 10);
        if (isNaN(parsedValue)) {
          // Input is not a valid integer, clear the field
          return {
            ...row,
            [name]: "", // Clear the field
          };
        }

        const otherValue = parseInt(
          row[
          name === "numberOfDetected"
            ? "numberOfRepeated"
            : "numberOfDetected"
          ],
          10
        ); // Get the other value

        // Check if "Number of Detected" is greater than "Number of Repeated"
        if (name === "numberOfDetected" && parsedValue > otherValue) {
          // Here, you can display an error message or prevent the change
          // For now, we'll set it to the other value
          return {
            ...row,
            [name]: otherValue, // Set to the other value
          };
        }

        return {
          ...row,
          [name]: parsedValue,
        };
      }
      return row;
    });

    // Update the state with the modified rows
    setRows(updatedRows);
  };

  const handleChangeCheckBox = (event: any, id: number) => {
    setRows((curr) =>
      curr.map((x) =>
        x.id === id
          ? {
            ...x,
            [event.target.name]: event.target.checked,
          }
          : x
      )
    );
  };
  const handleChangeAssay = (
    name: string,
    value: string,
    id: number,
    e: any
  ) => {
    setRows((curr) =>
      curr.map((x) =>
        x.id === id
          ? {
            ...x,
            [name]: value,
            organism: e.organism,
            testCode: e.testCode,
          }
          : x
      )
    );
  };
  ////////////-----------------Section For Searching-------------------///////////////////

  let intialSearchQuery = {
    performingLabId: 0,
    performingLabName: "",
    panelName: "",
    panelCode: "",
    assayName: "",
    organism: "",
    testCode: "",
    groupName: "",
    subPanelName: "",
  };

  const queryDisplayTagNames: StringRecord = {
    performingLabId: "Performing Lab",
    performingLabName: "Performing Lab",
    panelName: "Panel Name",
    panelCode: "Panel Code",
    assayName: "Display Name",
    organism: "Organism",
    testCode: "Test Code",
    groupName: "Group Name",
    subPanelName: "Sub Panel Name",
  };

  let [searchRequest, setSearchRequest] = useState(intialSearchQuery);
  type InputChangeEvent = HTMLInputElement | HTMLSelectElement;
  const onInputChangeSearch = (e: React.ChangeEvent<InputChangeEvent>) => {
    setSearchRequest({ ...searchRequest, [e.target.name]: e.target.value });
  };

  function resetSearch() {
    setSearchRequest({
      performingLabId: 0,
      performingLabName: "",
      panelName: "",
      panelCode: "",
      assayName: "",
      organism: "",
      testCode: "",
      groupName: "",
      subPanelName: "",
    });
    setSorting(sortById);
    setCurPage(1);
    setTriggerSearchData((prev) => !prev);
  }

  ////////////-----------------Section For Searching-------------------///////////////////

  ////////////-----------------Get Look Reference Labs Data-------------------///////////////////

  const { data: assayLookupData } = useQuery(
    ["oncology-panel-mapping", "assay-lookup"],
    async () => {
      const res = await OncologyPanelMappingService.AssayDataLookup();
      return res?.data?.data ?? [];
    },
    { staleTime: 5 * 60 * 1000 }
  );

  const { data: groupLookupData } = useQuery(
    ["oncology-panel-mapping", "group-lookup"],
    async () => {
      const res = await OncologyPanelMappingService.GroupLookup();
      return res?.data ?? [];
    },
    { staleTime: 5 * 60 * 1000 }
  );

  const { data: performingLabLookupData } = useQuery(
    ["oncology-panel-mapping", "performing-lab-lookup"],
    async () => {
      const res = await OncologyPanelMappingService.PerformingLabLookup();
      return res?.data ?? [];
    },
    { staleTime: 5 * 60 * 1000 }
  );

  const dropDownValues = useMemo(() => {
    const assayOptions =
      (assayLookupData ?? []).map((val: IAssayData) => ({
        value: val?.assayNameId,
        label: val?.assayName,
        organism: val?.organism,
        testCode: val?.testCode,
      })) ?? [];

    return {
      PerformingLabList: performingLabLookupData ?? [],
      AssayDataList: assayOptions,
      GroupList: groupLookupData ?? [],
    };
  }, [assayLookupData, groupLookupData, performingLabLookupData]);
  ////////////-----------------Get Look Reference Labs Data-------------------///////////////////

  ////////////-----------------Get All Data-------------------///////////////////
  const nullObj = useMemo(
    () => ({
      performingLabId: 0,
      performingLabName: "",
      panelName: "",
      panelCode: "",
      assayName: "",
      organism: "",
      testCode: "",
      groupName: "",
      antibioticClass: "",
      reportingRuleName: "",
      resistance: null,
    }),
    []
  );

  const trimmedSearchRequest = useMemo(() => {
    return Object.fromEntries(
      Object.entries(searchRequest).map(([key, value]) => [
        key,
        typeof value === "string" ? value.trim() : value,
      ])
    );
  }, [searchRequest]);

  const panelMappingQueryKey = useMemo(
    () => [
      "oncology-panel-mapping",
      "grid",
      {
        pageNumber: curPage,
        pageSize,
        sortColumn: sort?.clickedIconData,
        sortDirection: sort?.sortingOrder,
        refresh,
        triggerSearchData,
        searchRequest: trimmedSearchRequest,
      },
    ],
    [
      curPage,
      pageSize,
      sort?.clickedIconData,
      sort?.sortingOrder,
      refresh,
      triggerSearchData,
      trimmedSearchRequest,
    ]
  );

  const {
    data: panelMappingData,
    isFetching: loading,
  } = useQuery(
    panelMappingQueryKey,
    async () => {
      const res = await OncologyPanelMappingService.getPanelMapping({
        pageNumber: curPage,
        pageSize,
        queryModel: trimmedSearchRequest,
        sortColumn: sort?.clickedIconData,
        sortDirection: sort?.sortingOrder,
      });
      return res?.data;
    },
    {
      keepPreviousData: true,
      onError: (err: any) => {
        console.trace(err, "err");
      },
    }
  );

  const loadGridData = (shouldRefetch?: boolean, reset?: boolean) => {
    setIsAddButtonDisabled(false);
    if (reset) {
      setSorting(sortById);
      setCurPage(1);
      setSearchRequest(intialSearchQuery);
    }
    if (shouldRefetch) {
      queryClient.invalidateQueries(["oncology-panel-mapping", "grid"]);
    }
  };

  useEffect(() => {
    const totalRecord = panelMappingData?.totalRecord ?? 0;
    setTotal(totalRecord);
    setRows(panelMappingData?.result ?? []);
  }, [panelMappingData]);

  ////////////-----------------Get All Data-------------------//////////////////

  ////////////-----------------Save a Row-------------------///////////////////
  const createOrUpdateMutation = useMutation(
    (queryModel: any) =>
      OncologyPanelMappingService.createOrUpdatePanelMapping(queryModel),
    {
      onSuccess: (res: any) => {
        if (res?.data?.httpStatusCode === 200) {
          toast.success(t(res?.data?.message));
          queryClient.invalidateQueries(["oncology-panel-mapping", "grid"]);
        } else {
          toast.error(t(res?.data?.message));
        }
        setRequest(false);
        setIsAddButtonDisabled(false);
      },
      onError: (err: any) => {
        console.trace(err);
        setRequest(false);
        setIsAddButtonDisabled(false);
      },
    }
  );

  const handleSubmit = (row: ITableObj) => {
    setRequest(true);

    if (
      row?.performingLabId != 0 &&
      row?.panelName != "" &&
      row?.panelCode != "" &&
      row?.assayNameId != 0 &&
      row?.reportingRuleId != 0 &&
      row?.groupNameId != 0
    ) {
      if (
        row?.numberOfRepeated != null &&
        row?.numberOfRepeated != 0 &&
        row?.numberOfDetected != null &&
        row?.numberOfDetected != 0
      ) {
        if (row?.numberOfRepeated >= row?.numberOfDetected) {
          const queryModel = {
            id: row.id,
            panelId: row.panelId,
            assayNameId: row.assayNameId,
            reportingRuleId: row.reportingRuleId,
            performingLabId: row.performingLabId,
            groupNameId: row.groupNameId,
            panelName: row.panelName,
            panelCode: row.panelCode,
            organism: row.organism,
            testCode: row?.testCode,
            antibioticClass: row.antibioticClass,
            resistance: row.resistance,
            numberOfDetected: row?.numberOfDetected,
            numberOfRepeated: row?.numberOfRepeated,
            subPanelName: row?.subPanelName,
          };

          createOrUpdateMutation.mutate(queryModel);
        } else {
          toast.error(
            t(
              "NumberOfRepeated value must be greater than or equal to NumberOfDetected"
            )
          );
          setRequest(false);
        }
      } else {
        toast.error(
          t("Number of Detected And Repeated should be greater than 0")
        );
        setRequest(false);
      }
    } else {
      toast.error(t("Please Enter The Required Fields"));
      setRequest(false);
    }

    // setRequest(false);
  };
  ////////////-----------------Save a Row-------------------///////////////////

  const handleAllSelect = (checked: boolean, rows: any) => {
    let idsArr: any = [];
    rows.forEach((item: any) => {
      idsArr.push(item?.id);
    });

    if (checked) {
      setSelectedBox((pre: any) => {
        return {
          ...pre,
          id: idsArr,
        };
      });
    }
    if (!checked) {
      setSelectedBox((pre: any) => {
        return {
          ...pre,
          id: [],
        };
      });
    }
  };
  const handleChangePanelMappinfId = (checked: boolean, id: number) => {
    if (checked) {
      setSelectedBox((pre: any) => {
        return {
          ...pre,
          id: [...selectedBox.id, id],
        };
      });
    }
    if (!checked) {
      setSelectedBox((pre: any) => {
        return {
          ...pre,
          id: selectedBox.id.filter((item: any) => item !== id),
        };
      });
    }
  };

  const [selectedBox, setSelectedBox] = useState<any>({
    id: [],
  });
  const [isAddButtonDisabled, setIsAddButtonDisabled] = useState(false);

  const searchRef = useRef<any>(null);

  const handleSort = (columnName: any) => {
    searchRef.current.id = searchRef.current.id
      ? searchRef.current.id === "asc"
        ? (searchRef.current.id = "desc")
        : (searchRef.current.id = "asc")
      : (searchRef.current.id = "asc");

    setSorting({
      sortingOrder: searchRef?.current?.id,
      clickedIconData: columnName,
    });
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      setCurPage(1);
      setTriggerSearchData((prev) => !prev);
    }
  };

  // Handling searchedTags
  const [searchedTags, setSearchedTags] = useState<string[]>([]);

  const handleTagRemoval = (clickedTag: string) => {
    setSearchRequest((prevSearchRequest) => {
      return {
        ...prevSearchRequest,
        [clickedTag]: (intialSearchQuery as any)[clickedTag],
      };
    });
  };

  useEffect(() => {
    const uniqueKeys = new Set<string>();
    for (const [key, value] of Object.entries(searchRequest)) {
      if (value) {
        uniqueKeys.add(key);
      }
    }
    setSearchedTags(Array.from(uniqueKeys));
  }, [searchRequest]);

  useEffect(() => {
    if (searchedTags.length === 0) resetSearch();
  }, [searchedTags.length]);

  return (
    <>
      <div className="d-flex gap-4 flex-wrap mb-1">
        {searchedTags.map((tag) => (
          <div
            className="d-flex align-items-center cursor-pointer gap-1 p-2 rounded bg-light"
            onClick={() => handleTagRemoval(tag)}
          >
            <span className="fw-bold">{t(queryDisplayTagNames[tag])}</span>
            <i className="bi bi-x"></i>
          </div>
        ))}
      </div>
      <div className="d-flex flex-wrap gap-2 justify-content-center justify-content-sm-between align-items-center mb-2 col-12 responsive-flexed-actions">
        <div className="d-flex gap-2 responsive-flexed-actions">
          <div className="d-flex align-items-center">
            <span className="fw-400 mr-3">{t("Records")}</span>
            <select
              id="IDCompendiumDataPanelMapingRecords"
              className="form-select w-sm-125px w-90px h-33px rounded py-2"
              data-kt-select2="true"
              data-placeholder="Select option"
              data-dropdown-parent="#kt_menu_63b2e70320b73"
              data-allow-clear="true"
              onChange={(e) => {
                setPageSize(parseInt(e.target.value));
              }}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="50" selected>
                50
              </option>
              <option value="100">100</option>
            </select>
          </div>
          <div className="d-flex gap-2 gap-lg-3 justify-content-center justify-content-sm-start">
            <div className="mt-0">
              <PermissionComponent
                moduleName="ID LIS"
                pageName="Compendium Data"
                permissionIdentifier="AddNew"
              >
                <Button
                  id="IDCompendiumDataPanelMapingAddNew"
                  onClick={() => {
                    if (!isAddButtonDisabled) {
                      setRows((prevRows: any) => [
                        //createData("", "", "", "--select", "", "", "--select", "", true),
                        {
                          id: 0,
                          panelId: 0,
                          performingLabId: 0,
                          performingLabName: "",
                          panelName: "",
                          panelCode: "",
                          assayName: "",
                          organism: "",
                          testCode: "",
                          groupName: "",
                          assayNameId: 0,
                          groupNameId: 0,
                          numberOfRepeated: 1,
                          numberOfDetected: 1,
                          subPanelName: "",
                          rowStatus: true,
                        },
                        ...prevRows,
                      ]);
                      setIsAddButtonDisabled(true);
                    }
                  }}
                  variant="contained"
                  color="success"
                  className="btn btn-primary btn-sm text-capitalize fw-400"
                  disabled={loading}
                  sx={{
                    "&.Mui-disabled": {
                      opacity: "0.65",
                      backgroundColor: "#69A54B",
                      color: "white",
                    },
                  }}
                >
                  <i className="bi bi-plus-lg"></i>
                  {t("Add New")}
                </Button>
              </PermissionComponent>
              {/* <button
                id="IDCompendiumDataPanelMapingSearch"
                onClick={() => {
                  showArchivedModal(true);
                }}
                className="btn btn-info btn-sm fw-500 ms-2"
                aria-controls="archieved"
              >
                {t("Archive")}
              </button> */}
            </div>
            <div>
              {/* <AnyPermission
                moduleName="ID LIS"
                pageName="Compendium Data"
                permissionIdentifiers={[
                  "ExportAllRecords",
                  "ExportSelectedRecords",
                ]}
              >
                <StyledDropButton
                  id="IDCompendiumDataPanelMapingExportData"
                  aria-controls={openDrop ? "demo-positioned-menu2" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openDrop ? "true" : undefined}
                  onClick={(event) => handleClick(event, "dropdown2")}
                  className="btn btn-excle btn-sm"
                >
                  <i
                    style={{
                      color: "white",
                      fontSize: "20px",
                      paddingLeft: "2px",
                    }}
                    className="fa"
                  >
                    &#xf1c3;
                  </i>
                  <span className="svg-icon svg-icon-5 m-0">
                    <ArrowBottomIcon />
                  </span>
                </StyledDropButton>
                <StyledDropMenu
                  aria-labelledby="demo-positioned-button2"
                  anchorEl={anchorEl.dropdown2}
                  open={Boolean(anchorEl.dropdown2)}
                  onClose={() => handleClose("dropdown2")}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <PermissionComponent
                    moduleName="ID LIS"
                    pageName="Compendium Data"
                    permissionIdentifier="ExportAllRecords"
                  >
                    <MenuItem className="p-0">
                      <a
                        id="IDCompendiumDataPanelMapingExportAllRecord"
                        className="w-auto text-dark w-200px "
                        onClick={() => {
                          handleClose("dropdown2");
                          downloadAll();
                        }}
                      >
                        {t("Export All Records")}
                      </a>
                    </MenuItem>
                  </PermissionComponent>
                  <PermissionComponent
                    moduleName="ID LIS"
                    pageName="Compendium Data"
                    permissionIdentifier="ExportSelectedRecords"
                  >
                    <MenuItem className="p-0">
                      <a
                        id="IDCompendiumDataPanelMapingExportSelectedRecords"
                        className="w-auto w-100px text-dark"
                        onClick={() => {
                          handleClose("dropdown2");
                          downloadSelected();
                        }}
                      >
                        {t("Export Selected Records")}
                      </a>
                    </MenuItem>
                  </PermissionComponent>
                </StyledDropMenu>
              </AnyPermission> */}
            </div>
          </div>
        </div>
        <div className="d-flex flex-wrap gap-3 justify-content-center justify-content-sm-between align-items-center">
          <div className="d-flex align-items-center gap-2 gap-lg-3">
            <button
              id="IDCompendiumDataPanelMapingSearch"
              onClick={() => {
                setCurPage(1);
                setTriggerSearchData((prev) => !prev);
              }}
              className="btn btn-info btn-sm fw-500"
              aria-controls="Search"
            >
              {t("Search")}
            </button>
            <button
              onClick={resetSearch}
              type="button"
              className="btn btn-secondary btn-sm btn-secondary--icon fw-500"
              id="IDCompendiumDataPanelMapingReset"
            >
              <span>
                <span>{t("Reset")}</span>
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className="card">
        <Box sx={{ height: "auto", width: "100%" }}>
          <div className="table_bordered overflow-hidden">
            <TableContainer
              sx={
                isMobile
                  ? {}
                  : {
                    maxHeight: "calc(100vh - 100px)",
                    "&::-webkit-scrollbar": {
                      width: 7,
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "#fff",
                    },
                    "&:hover": {
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "var(--kt-gray-400)",
                        borderRadius: 2,
                      },
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "var(--kt-gray-400)",
                      borderRadius: 2,
                    },
                  }
              }
              // component={Paper}
              className="shadow-none"
            // sx={{ maxHeight: 'calc(100vh - 100px)' }}
            >
              <Table
                // stickyHeader
                aria-label="sticky table collapsible"
                className="table table-cutome-expend table-bordered table-sticky-header table-head-2-bg table-bg table-head-custom table-vertical-center border-0 mb-0"
              >
                <TableHead>
                  <TableRow className="h-40px">
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      <Select
                        inputId="IDCompendiumDataPanelMapingPerformingLab"
                        menuPortalTarget={document.body}
                        className="my-1"
                        theme={(theme) => styles(theme)}
                        placeholder={t("Select...")}
                        options={dropDownValues?.PerformingLabList}
                        styles={reactSelectSMStyle}
                        onChange={(event: any) => {
                          setSearchRequest({
                            ...searchRequest,
                            performingLabId: event.value,
                          });
                        }}
                        value={dropDownValues?.PerformingLabList.filter(
                          function (option: any) {
                            return (
                              option.value === searchRequest?.performingLabId
                            );
                          }
                        )}
                        onKeyDown={handleKeyPress}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        id="IDCompendiumDataPanelMapingPanelName"
                        type="text"
                        name="panelName"
                        className="form-control bg-white  min-w-100px w-100 rounded-2 fs-8 h-30px"
                        placeholder={t("Search ...")}
                        value={searchRequest.panelName}
                        onChange={onInputChangeSearch}
                        onKeyDown={handleKeyPress}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        id="IDCompendiumDataPanelMapingSubPanelName"
                        type="text"
                        name="subPanelName"
                        className="form-control bg-white  min-w-100px w-100 rounded-2 fs-8 h-30px"
                        placeholder={t("Search ...")}
                        value={searchRequest.subPanelName}
                        onChange={onInputChangeSearch}
                        onKeyDown={handleKeyPress}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        id="IDCompendiumDataPanelMapingPanelCode"
                        type="text"
                        name="panelCode"
                        className="form-control bg-white  min-w-100px w-100 rounded-2 fs-8 h-33px"
                        placeholder={t("Search ...")}
                        value={searchRequest.panelCode}
                        onChange={onInputChangeSearch}
                        onKeyDown={handleKeyPress}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        id="IDCompendiumDataPanelMapingAssayName"
                        type="text"
                        name="assayName"
                        className="form-control bg-white  min-w-100px w-100 rounded-2 fs-8 h-30px"
                        placeholder={t("Search ...")}
                        value={searchRequest.assayName}
                        onChange={onInputChangeSearch}
                        onKeyDown={handleKeyPress}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        id="IDCompendiumDataPanelMapingOrganism"
                        type="text"
                        name="organism"
                        className="form-control bg-white  min-w-100px w-100 rounded-2 fs-8 h-30px"
                        placeholder={t("Search ...")}
                        value={searchRequest.organism}
                        onChange={onInputChangeSearch}
                        onKeyDown={handleKeyPress}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        id="IDCompendiumDataPanelMapingTestCode"
                        type="text"
                        name="testCode"
                        className="form-control bg-white  min-w-100px w-100 rounded-2 fs-8 h-30px"
                        placeholder={t("Search ...")}
                        value={searchRequest.testCode}
                        onChange={onInputChangeSearch}
                        onKeyDown={handleKeyPress}
                      />
                    </TableCell>

                    <TableCell>
                      <input
                        id="IDCompendiumDataPanelMapingGroupName"
                        type="text"
                        name="groupName"
                        className="form-control bg-white  min-w-100px w-100 rounded-2 fs-8 h-30px"
                        placeholder={t("Search ...")}
                        value={searchRequest.groupName}
                        onChange={onInputChangeSearch}
                        onKeyDown={handleKeyPress}
                      />
                    </TableCell>

                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell className="w-25px min-w-25px">
                      <div className="d-flex justify-content-center">
                        <label className="form-check form-check-sm form-check-solid">
                          <input
                            id={`PanelMapingCheckAll`}
                            className="form-check-input"
                            type="checkbox"
                            onChange={(e) =>
                              handleAllSelect(e.target.checked, rows)
                            }
                          />
                        </label>
                      </div>
                    </TableCell>
                    <TableCell className="min-w-50px">{t("Actions")}</TableCell>
                    <TableCell sx={{ width: "max-content" }}>
                      <div
                        onClick={() => handleSort("performingLabName")}
                        className="d-flex justify-content-between cursor-pointer"
                        id=""
                        ref={searchRef}
                      >
                        <div style={{ width: "max-content" }}>
                          {t("Performing Lab")}
                        </div>

                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                          <ArrowUp
                            CustomeClass={`${sort.sortingOrder === "desc" &&
                              sort.clickedIconData === "performingLabName"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0 "`}
                          />
                          <ArrowDown
                            CustomeClass={`${sort.sortingOrder === "asc" &&
                              sort.clickedIconData === "performingLabName"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0`}
                          />
                        </div>
                      </div>
                    </TableCell>
                    <TableCell sx={{ width: "max-content" }}>
                      <div
                        onClick={() => handleSort("panelName")}
                        className="d-flex justify-content-between cursor-pointer"
                        id=""
                        ref={searchRef}
                      >
                        <div style={{ width: "max-content" }}>
                          {t("Panel Name")}
                        </div>

                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                          <ArrowUp
                            CustomeClass={`${sort.sortingOrder === "desc" &&
                              sort.clickedIconData === "panelName"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0 "`}
                          />
                          <ArrowDown
                            CustomeClass={`${sort.sortingOrder === "asc" &&
                              sort.clickedIconData === "panelName"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0`}
                          />
                        </div>
                      </div>
                    </TableCell>
                    <TableCell sx={{ width: "max-content" }}>
                      <div
                        onClick={() => handleSort("subPanelName")}
                        className="d-flex justify-content-between cursor-pointer"
                        id=""
                        ref={searchRef}
                      >
                        <div style={{ width: "max-content" }}>
                          {t("Sub Panel Name")}
                        </div>

                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                          <ArrowUp
                            CustomeClass={`${sort.sortingOrder === "desc" &&
                              sort.clickedIconData === "subPanelName"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0 "`}
                          />
                          <ArrowDown
                            CustomeClass={`${sort.sortingOrder === "asc" &&
                              sort.clickedIconData === "subPanelName"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0`}
                          />
                        </div>
                      </div>
                    </TableCell>
                    <TableCell sx={{ width: "max-content" }}>
                      <div
                        onClick={() => handleSort("panelCode")}
                        className="d-flex justify-content-between cursor-pointer"
                        id=""
                        ref={searchRef}
                      >
                        <div style={{ width: "max-content" }}>
                          {t("Panel Code")}
                        </div>

                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                          <ArrowUp
                            CustomeClass={`${sort.sortingOrder === "desc" &&
                              sort.clickedIconData === "panelCode"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0 "`}
                          />
                          <ArrowDown
                            CustomeClass={`${sort.sortingOrder === "asc" &&
                              sort.clickedIconData === "panelCode"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0`}
                          />
                        </div>
                      </div>
                    </TableCell>
                    <TableCell sx={{ width: "max-content" }}>
                      <div
                        onClick={() => handleSort("assayName")}
                        className="d-flex justify-content-between cursor-pointer"
                        id=""
                        ref={searchRef}
                      >
                        <div style={{ width: "max-content" }}>
                          {t("Display(Assay) Name")}
                        </div>

                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                          <ArrowUp
                            CustomeClass={`${sort.sortingOrder === "desc" &&
                              sort.clickedIconData === "assayName"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0 "`}
                          />
                          <ArrowDown
                            CustomeClass={`${sort.sortingOrder === "asc" &&
                              sort.clickedIconData === "assayName"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0`}
                          />
                        </div>
                      </div>
                    </TableCell>
                    <TableCell sx={{ width: "max-content" }}>
                      <div
                        onClick={() => handleSort("organism")}
                        className="d-flex justify-content-between cursor-pointer"
                        id=""
                        ref={searchRef}
                      >
                        <div style={{ width: "max-content" }}>
                          {t("Organism")}
                        </div>

                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                          <ArrowUp
                            CustomeClass={`${sort.sortingOrder === "desc" &&
                              sort.clickedIconData === "organism"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0 "`}
                          />
                          <ArrowDown
                            CustomeClass={`${sort.sortingOrder === "asc" &&
                              sort.clickedIconData === "organism"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0`}
                          />
                        </div>
                      </div>
                    </TableCell>
                    <TableCell sx={{ width: "max-content" }}>
                      <div
                        onClick={() => handleSort("testCode")}
                        className="d-flex justify-content-between cursor-pointer"
                        id=""
                        ref={searchRef}
                      >
                        <div style={{ width: "max-content" }}>
                          {t("Test Code")}
                        </div>

                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                          <ArrowUp
                            CustomeClass={`${sort.sortingOrder === "desc" &&
                              sort.clickedIconData === "testCode"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0 "`}
                          />
                          <ArrowDown
                            CustomeClass={`${sort.sortingOrder === "asc" &&
                              sort.clickedIconData === "testCode"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0`}
                          />
                        </div>
                      </div>
                    </TableCell>
                    <TableCell sx={{ width: "max-content" }}>
                      <div
                        onClick={() => handleSort("groupName")}
                        className="d-flex justify-content-between cursor-pointer"
                        id=""
                        ref={searchRef}
                      >
                        <div style={{ width: "max-content" }}>
                          {t("Group Name")}
                        </div>

                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                          <ArrowUp
                            CustomeClass={`${sort.sortingOrder === "desc" &&
                              sort.clickedIconData === "groupName"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0 "`}
                          />
                          <ArrowDown
                            CustomeClass={`${sort.sortingOrder === "asc" &&
                              sort.clickedIconData === "groupName"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0`}
                          />
                        </div>
                      </div>
                    </TableCell>
                    <TableCell sx={{ width: "max-content" }}>
                      <div
                        onClick={() => handleSort("numberOfRepeated")}
                        className="d-flex justify-content-between cursor-pointer"
                        id=""
                        ref={searchRef}
                      >
                        <div style={{ width: "max-content" }}>
                          {t("Number Of Repeated")}
                        </div>

                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                          <ArrowUp
                            CustomeClass={`${sort.sortingOrder === "desc" &&
                              sort.clickedIconData === "numberOfRepeated"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0 "`}
                          />
                          <ArrowDown
                            CustomeClass={`${sort.sortingOrder === "asc" &&
                              sort.clickedIconData === "numberOfRepeated"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0`}
                          />
                        </div>
                      </div>
                    </TableCell>
                    <TableCell sx={{ width: "max-content" }}>
                      <div
                        onClick={() => handleSort("numberOfDetected")}
                        className="d-flex justify-content-between cursor-pointer"
                        id=""
                        ref={searchRef}
                      >
                        <div style={{ width: "max-content" }}>
                          {t("Number Of Detected")}
                        </div>

                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                          <ArrowUp
                            CustomeClass={`${sort.sortingOrder === "desc" &&
                              sort.clickedIconData === "numberOfDetected"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0 "`}
                          />
                          <ArrowDown
                            CustomeClass={`${sort.sortingOrder === "asc" &&
                              sort.clickedIconData === "numberOfDetected"
                              ? "text-success fs-7"
                              : "text-gray-700 fs-7"
                              }  p-0 m-0`}
                          />
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableCell colSpan={15}>
                      <Loader />
                    </TableCell>
                  ) : rows.length ? (
                    rows.map((item: any, index) => {
                      return (
                        <Row
                          row={item}
                          index={index}
                          rows={rows}
                          setRows={setRows}
                          dropDownValues={dropDownValues}
                          handleChange={handleChange}
                          handleChangeCheckBox={handleChangeCheckBox}
                          handleChangeAssay={handleChangeAssay}
                          // updateRow={updateRow}
                          // handleDelete={deleteRow}
                          handleSubmit={handleSubmit}
                          loadGridData={loadGridData}
                          handleChangePanelMappinfId={
                            handleChangePanelMappinfId
                          }
                          selectedBox={selectedBox}
                          request={request}
                          setRequest={setRequest}
                          handleChangeForDetected={handleChangeForDetected}
                          handleChangeforRepeated={handleChangeforRepeated}
                          setIsAddButtonDisabled={setIsAddButtonDisabled}
                        />
                      );
                    })
                  ) : (
                    <NoRecord colSpan={15} />
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Box>
      </div>
      <div className="card">
        <Box sx={{ height: "auto", width: "100%" }}>
          <CustomPagination
            curPage={curPage}
            nextPage={nextPage}
            pageNumbers={pageNumbers}
            pageSize={pageSize}
            prevPage={prevPage}
            showPage={showPage}
            total={total}
            totalPages={totalPages}
          />
        </Box>
      </div>
      <BootstrapModal
        size="xl"
        BootstrapModal
        show={isArchivedModalShown}
        onHide={closeArchivedModal}
        backdrop="static"
        keyboard={false}
      >
        <BootstrapModal.Header closeButton className="bg-light-primary m-0 p-5">
          <h4>{t("Archive")}</h4>
        </BootstrapModal.Header>
        <BootstrapModal.Body className="pt-0">
          <ArchivedIdCompendium
            curPage={curPage}
            pageSize={pageSize}
            loadGridData={loadGridData}
          />
        </BootstrapModal.Body>
        <BootstrapModal.Footer className="p-0"></BootstrapModal.Footer>
      </BootstrapModal>
      {/* ==========================================================================================
                    //====================================  PAGINATION END =====================================
                    //============================================================================================ */}
    </>
  );
}
